import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'patient-portal/chat-members-modal';

export const CHAT_MEMBERS_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const chatMembersModalActions = {
  open: createAction(CHAT_MEMBERS_MODAL.OPEN),
  close: createAction(CHAT_MEMBERS_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  memberList: [],
  chatRoomName: '',
  date: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHAT_MEMBERS_MODAL.OPEN: {
      return {
        ...state,
        memberList: payload.memberList,
        chatRoomName: payload.chatRoomName,
        date: payload.date,
        opened: true,
      };
    }

    case CHAT_MEMBERS_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/chat-members-modal.js